import qs from 'query-string';
import * as api from '../api/index';

const initAppAction = ({ commit }, payload ) => {
    commit('setState', payload)
}

const newSearchAction = ({ commit, state }, payload) => {
    const params = {
        upcoming_page: state.upcoming.page,
        past_page: state.past.page,
    };

    const upcomingFilter = state.upcoming.filters;
    if(upcomingFilter.options) {
        const selected = upcomingFilter.options.filter(option => option.selected);
        if(selected.length) {
            params['filter_upcoming'] = selected.map(f => f.value).join(',')
        }
    }

    const pastFilter = state.past.filters;
    if(pastFilter.options) {
        const selected = pastFilter.options.filter(option => option.selected);
        if(selected.length) {
            params['filter_past'] = selected.map(f => f.value).join(',')
        }
    }

    commit('setLoading', {
        id: payload,
        loading: true
    });

    api.search(state.api, params, state.apiKey )
        .then((res) => {
            commit('setItems', {
                upcoming: res.upcoming.events || [],
                past: res.past.events || []
            });
            commit('setTotal', 
            {
                upcoming: res.upcoming.total || 0,
                past: res.past.total || 0
            });
            commit('setCanLoadMore', {
                upcoming: res.upcoming.canLoadMore || false,
                past: res.past.canLoadMore || false
            });
            commit('setLoading', {
                id: payload,
                loading: false
            });
        });
    
}

const setUrlAction = ({ state }) => {
    const params = {
        load_upcoming: state.upcoming.page,
        load_past: state.past.page,
    }

    const upcomingFilter = state.upcoming.filters;
    if(upcomingFilter.options) {
        const selected = upcomingFilter.options.filter(option => option.selected);
        if(selected.length) {
            params['filter_upcoming'] = selected.map(f => f.value).join(',')
        }
    }

    const pastFilter = state.past.filters;
    if(pastFilter.options) {
        const selected = pastFilter.options.filter(option => option.selected);
        if(selected.length) {
            params['filter_past'] = selected.map(f => f.value).join(',')
        }
    }

    const url = `${window.location.protocol}//${window.location.host + window.location.pathname}?${qs.stringify(params)}`;
    window.history.replaceState({}, document.title, url);
}

const actions = {
    initApp: initAppAction,
    setUrl: setUrlAction,
    newSearch: newSearchAction,
};

export default actions;